import PageHeader from '../../components/common/PageHeader';
import Pill from '../../components/common/Pill';
import { NOVIDADES } from '../../utils/novidades';

const MESES = [
  'janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho',
  'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro',
];

function formatDataLonga(iso) {
  const [ano, mes, dia] = iso.split('-');
  return `${Number(dia)} de ${MESES[Number(mes) - 1]} de ${ano}`;
}

const TAG_INFO = {
  novo: { label: 'Novo', tone: 'success' },
  atualizado: { label: 'Atualizado', tone: 'warning' },
  removido: { label: 'Removido', tone: 'danger' },
};

export default function Novidades() {
  return (
    <div>
      <PageHeader titulo="Novidades" subtitulo="O que mudou no sistema, entrega por entrega." />

      <div className="d-flex flex-column gap-3">
        {NOVIDADES.map((bloco) => (
          <div key={bloco.data} className="card-soft" style={{ padding: 24 }}>
            <div style={{ fontSize: 14, fontWeight: 700, color: 'var(--am-tinta)', marginBottom: 16 }}>
              {formatDataLonga(bloco.data)}
            </div>
            <div className="d-flex flex-column gap-3">
              {bloco.itens.map((item, i) => {
                const info = TAG_INFO[item.tag] || TAG_INFO.novo;
                const ehUltimo = i === bloco.itens.length - 1;
                return (
                  <div
                    key={i}
                    className="d-flex gap-3"
                    style={ehUltimo ? undefined : { paddingBottom: 14, borderBottom: '1px solid var(--am-borda-2)' }}
                  >
                    <div style={{ flexShrink: 0, width: 96 }}>
                      <Pill tone={info.tone}>{info.label}</Pill>
                    </div>
                    <div>
                      <div style={{ fontSize: 14, fontWeight: 700, color: 'var(--am-tinta)' }}>{item.titulo}</div>
                      <div style={{ fontSize: 13, color: 'var(--am-cinza-texto-2)', marginTop: 3, lineHeight: 1.5 }}>
                        {item.descricao}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
